import { z } from "zod";
import { PaymentStatus } from "../utils";

export const paymentFormSchema = z.object({
  creatorId: z.string({ required_error: "Selecione o creator" }).min(1, "Selecione o creator"),
  creatorBankAccountId: z.string({ required_error: "Selecione a conta bancária" }).min(1, "Selecione a conta bancária"),
  status: z.nativeEnum(PaymentStatus, { required_error: "Selecione o status" }),
  value: z
    .number({ invalid_type_error: "Informe o valor do pagamento" })
    .positive("Informe um valor maior que zero"),
  paymentDate: z.date({ required_error: "Informe a data do pagamento" }),
  referencePaymentDate: z.date().optional(),
});

export type PaymentFormValues = z.infer<typeof paymentFormSchema>;

